// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_1weEBrJXdVCmw3AfFMOQkM","checked":"_1kfih-YQM9G4gtWraednIO","disabled":"_2_Dgf73kqlA53kbpO1JXoa","selected":"_2qs8InUsMo6ih1IVz7VRwK"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/cricket/css/oddsButton.css
// module id = 764
// module chunks = 0